import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';

interface DuplicateSectorParams {
	propId: string;
	areaId: string;
	sectorId: string;
	amount: number;
}

export function useDuplicateSector() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({ propId, areaId, sectorId, amount }: DuplicateSectorParams) => {
			try {
				return (
					await api.post(
						`/user/prop/${propId}/area/${areaId}/sector/duplicate/${sectorId}/${amount}`,
						undefined,
						{ params: { forBinding } }
					)
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao replicar setor');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['sectors'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
		},
		onError: (error) =>
			console.error('Erro ao replicar setor:', getApiErrorMessage(error, 'Erro ao replicar setor')),
	});
}
